import { render, staticRenderFns } from "./planTable.vue?vue&type=template&id=1daf95fa&scoped=true"
import script from "./planTable.vue?vue&type=script&lang=js"
export * from "./planTable.vue?vue&type=script&lang=js"
import style0 from "./planTable.vue?vue&type=style&index=0&id=1daf95fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daf95fa",
  null
  
)

export default component.exports